import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  sanitizer = inject(DomSanitizer);

  transform(value: string | unknown): unknown {
    if (!value) return value;
    return this.sanitizer.bypassSecurityTrustHtml(value as string);
  }
}
